import KunLoading34 from './src/index'

KunLoading34.install = function (Vue) {
	Vue.component(KunLoading34.name, KunLoading34);
}

export default KunLoading34;
